module.exports = __webpack_public_path__ + "img/num-02.34a8b128.png";